package com.shadowings.gero.data.lessons.chapter14

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.shadowings.gero.data.repository.Hiero
import com.shadowings.gero.data.repository.SentenceOptions
import com.shadowings.gero.domain.model.Characters
import com.shadowings.gero.domain.model.ExplanationContent
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.domain.model.IExplanation
import com.shadowings.gero.domain.model.IQuizContent
import com.shadowings.gero.domain.model.MultiPressContent
import com.shadowings.gero.domain.model.Option
import com.shadowings.gero.domain.model.SingleSelectionContent
import com.shadowings.gero.presentation.component.MdCWord
import com.shadowings.gero.presentation.model.Verb
import com.shadowings.gero.presentation.model.Word
import kotlin.random.Random
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.exp_content_il_dimostrativo_pn_1
import gero.composeapp.generated.resources.exp_content_il_dimostrativo_pn_10
import gero.composeapp.generated.resources.exp_content_il_dimostrativo_pn_11
import gero.composeapp.generated.resources.exp_content_il_dimostrativo_pn_12
import gero.composeapp.generated.resources.exp_content_il_dimostrativo_pn_13
import gero.composeapp.generated.resources.exp_content_il_dimostrativo_pn_14
import gero.composeapp.generated.resources.exp_content_il_dimostrativo_pn_15
import gero.composeapp.generated.resources.exp_content_il_dimostrativo_pn_2
import gero.composeapp.generated.resources.exp_content_il_dimostrativo_pn_3
import gero.composeapp.generated.resources.exp_content_il_dimostrativo_pn_4
import gero.composeapp.generated.resources.exp_content_il_dimostrativo_pn_5
import gero.composeapp.generated.resources.exp_content_il_dimostrativo_pn_6
import gero.composeapp.generated.resources.exp_content_il_dimostrativo_pn_7
import gero.composeapp.generated.resources.exp_content_il_dimostrativo_pn_8
import gero.composeapp.generated.resources.exp_content_il_dimostrativo_pn_9
import gero.composeapp.generated.resources.exp_title_il_dimostrativo_pn
import gero.composeapp.generated.resources.quiz_il_dimostrativo_pn_1
import gero.composeapp.generated.resources.quiz_il_dimostrativo_pn_1_opt1
import gero.composeapp.generated.resources.quiz_il_dimostrativo_pn_1_opt2
import gero.composeapp.generated.resources.quiz_il_dimostrativo_pn_1_opt3
import gero.composeapp.generated.resources.quiz_il_dimostrativo_pn_1_opt4
import gero.composeapp.generated.resources.quiz_il_dimostrativo_pn_2
import gero.composeapp.generated.resources.quiz_il_dimostrativo_pn_2_opt1
import gero.composeapp.generated.resources.quiz_il_dimostrativo_pn_2_opt2
import gero.composeapp.generated.resources.quiz_il_dimostrativo_pn_2_opt3
import gero.composeapp.generated.resources.quiz_il_dimostrativo_pn_2_opt4

fun getIlDimostrativoPnContent(): List<IExplanation> {
    return listOf(
        ExplanationContent(
            title = Res.string.exp_title_il_dimostrativo_pn,
            content = Res.string.exp_content_il_dimostrativo_pn_1,
            face = Faces.Idle,
            character = Characters.Nilo,
            composable = {
                Box(modifier = Modifier.fillMaxWidth(), contentAlignment = Alignment.Center) {
                    MdCWord(word = "Q3:N35", rtl = false, cart = false, size = 64.dp)
                }
            }
        ),
        ExplanationContent(
            title = Res.string.exp_title_il_dimostrativo_pn,
            content = Res.string.exp_content_il_dimostrativo_pn_2,
            face = Faces.Idle,
            character = Characters.Alyn,
            composable = {
                Box(modifier = Modifier.fillMaxWidth(), contentAlignment = Alignment.Center) {
                    MdCWord(word = "Q3:N35", rtl = false, cart = false, size = 64.dp)
                }
            }
        ),
        ExplanationContent(
            title = Res.string.exp_title_il_dimostrativo_pn,
            content = Res.string.exp_content_il_dimostrativo_pn_3,
            face = Faces.Happy,
            character = Characters.Nilo,
            composable = {
                Box(modifier = Modifier.fillMaxWidth(), contentAlignment = Alignment.Center) {
                    MdCWord(word = "Q3:N35", rtl = false, cart = false, size = 64.dp)
                }
            }
        ),
        ExplanationContent(
            title = Res.string.exp_title_il_dimostrativo_pn,
            content = Res.string.exp_content_il_dimostrativo_pn_4,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_il_dimostrativo_pn,
            content = Res.string.exp_content_il_dimostrativo_pn_5,
            face = Faces.Doubt,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_il_dimostrativo_pn,
            content = Res.string.exp_content_il_dimostrativo_pn_6,
            face = Faces.Idle,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_il_dimostrativo_pn,
            content = Res.string.exp_content_il_dimostrativo_pn_7,
            face = Faces.Idle,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_il_dimostrativo_pn,
            content = Res.string.exp_content_il_dimostrativo_pn_8,
            face = Faces.Happy,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_il_dimostrativo_pn,
            content = Res.string.exp_content_il_dimostrativo_pn_9,
            face = Faces.Surprised,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_il_dimostrativo_pn,
            content = Res.string.exp_content_il_dimostrativo_pn_10,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_il_dimostrativo_pn,
            content = Res.string.exp_content_il_dimostrativo_pn_11,
            face = Faces.Idle,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_il_dimostrativo_pn,
            content = Res.string.exp_content_il_dimostrativo_pn_12,
            face = Faces.Idle,
            character = Characters.Alyn,
            composable = {
                Box(modifier = Modifier.fillMaxWidth(), contentAlignment = Alignment.Center) {
                    MdCWord(word = "Q3:N35", rtl = false, cart = false, size = 64.dp)
                }
            }
        ),
        ExplanationContent(
            title = Res.string.exp_title_il_dimostrativo_pn,
            content = Res.string.exp_content_il_dimostrativo_pn_13,
            face = Faces.Idle,
            character = Characters.Alyn,
            composable = {
                Box(modifier = Modifier.fillMaxWidth(), contentAlignment = Alignment.Center) {
                    MdCWord(word = "X1:N35", rtl = false, cart = false, size = 64.dp)
                }
            }
        ),
        ExplanationContent(
            title = Res.string.exp_title_il_dimostrativo_pn,
            content = Res.string.exp_content_il_dimostrativo_pn_14,
            face = Faces.Idle,
            character = Characters.Alyn,
            composable = {
                Box(modifier = Modifier.fillMaxWidth(), contentAlignment = Alignment.Center) {
                    MdCWord(word = "N35:N35", rtl = false, cart = false, size = 64.dp)
                }
            }
        ),
        ExplanationContent(
            title = Res.string.exp_title_il_dimostrativo_pn,
            content = Res.string.exp_content_il_dimostrativo_pn_15,
            face = Faces.Happy,
            character = Characters.Nilo,
        ),
    )
}

fun getIlDimostrativoPnQuizContent(
    hiero: List<Hiero> = emptyList(),
    words: List<Word> = emptyList(),
    verbs: List<Verb> = emptyList(),
    languageCode: String = "",
    verbSentences: List<SentenceOptions> = emptyList(),
    random: Random = Random
): List<IQuizContent> {
    val specificQuizzes: List<IQuizContent> = listOf(
        SingleSelectionContent(
            text = Res.string.quiz_il_dimostrativo_pn_1,
            detail = "",
            options = listOf(
                Option(Res.string.quiz_il_dimostrativo_pn_1_opt1, correct = true),
                Option(Res.string.quiz_il_dimostrativo_pn_1_opt2, correct = false),
                Option(Res.string.quiz_il_dimostrativo_pn_1_opt3, correct = false),
                Option(Res.string.quiz_il_dimostrativo_pn_1_opt4, correct = false)
            ).shuffled(random)
        ),
        SingleSelectionContent(
            text = Res.string.quiz_il_dimostrativo_pn_2,
            detail = "",
            options = listOf(
                Option(Res.string.quiz_il_dimostrativo_pn_2_opt1, correct = true),
                Option(Res.string.quiz_il_dimostrativo_pn_2_opt2, correct = false),
                Option(Res.string.quiz_il_dimostrativo_pn_2_opt3, correct = false),
                Option(Res.string.quiz_il_dimostrativo_pn_2_opt4, correct = false)
            ).shuffled(random)
        )
    )

    val sentenceQuizzes = getRieccoloDiNuovoQuizContent(
        hiero = hiero,
        words = words,
        verbs = verbs,
        languageCode = languageCode,
        verbSentences = verbSentences,
        random = random,
        demonstrativeOnly = true
    ).filterNot { it is MultiPressContent }.take(8)

    return specificQuizzes + sentenceQuizzes
}
